import { ChevronsUpDown } from 'lucide-react'
import { cn } from '@/lib/utils'

interface SwitcherChevronProps {
  className?: string
}

/**
 * Small shared chevron used on every v4 combo-box trigger (org, venue, etc.).
 * Keeps the stroke/size/opacity consistent so individual switchers don't
 * repeat the styling.
 */
export function SwitcherChevron({ className }: SwitcherChevronProps) {
  return (
    <ChevronsUpDown
      strokeWidth={3}
      className={cn('size-3.5 shrink-0 opacity-60', className)}
    />
  )
}
